module.exports = __webpack_public_path__ + "static/media/cigna.9d02e463.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/images/partner/logos/cigna.png
// module id = 31
// module chunks = 0